export default {
    name: 'InputFileSelector',

    props: {
        picked: Array,
        files: Array
    },

    computed: {
        shownFiles: function () {
            return this.files.filter(file => file.removed === false)
        },
        deletedFiles: function (){
            return this.files.filter(file => file.removed === true)
        }
    },

    methods: {
        handleFileChange(e) {
            this.$emit('input', e.target.files);
            e.target.value = ''
        },
        removeFile(removedFile) {
            this.$emit('removePicked', removedFile);
        },
        removeBookingFile(removedFile) {
            this.$emit('removeFile', removedFile);
        },
        restoreBookingFile(restoredFile) {
            this.$emit('restoreFile', restoredFile);
        }
    }
}
